import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { delay } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { UtilService } from './util.service';
@Injectable({
  providedIn: 'root'
})
export class ApplicantDetailsService {

  constructor(private util: UtilService) { }

  getApplicantDetails () {
    return this.util.getJson(atob(sessionStorage.getItem("transactionid")));
     // Make service call here to get applicant details.
  }
}
